import { PlanVariantEssentialPlusCreditsLabelProps } from '../../types/components/pricing/PlanVariantEssentialPlusCreditsLabel';

const PlanVariantEssentialPlusCreditsLabel: React.FC<PlanVariantEssentialPlusCreditsLabelProps> = ({
  planVariant,
}) => {
  if (!planVariant) return;

  const getPlanIntervalShorthand = (): string => {
    return planVariant.interval === 'month' ? 'mo' : 'yr';
  }

  const getText = (): string => {
    return planVariant.recurring_credits === 0
    ? 'Essentials catalog assets only - no recurring credits'
    : `Essentials + ${planVariant.recurring_credits} Credits/${getPlanIntervalShorthand()}`
  }

  return (
    <span
      cy-test-id="plan-variant-essential-plus-credits-label"
      className="w-full text-center text-a-blue inter text-16 font-medium leading-24"
    >
      {getText()}
    </span>
  );
}

export default PlanVariantEssentialPlusCreditsLabel;
